import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import HomeView from "../views/HomeView.vue";
import ProfileView from "@/views/ProfileView.vue";
import ForbiddenView from "@/views/ForbiddenView.vue";
import NotFound from "@/components/NotFound.vue";
import RombelView from "@/views/RombelView.vue";
import DetailSiswa from "@/components/DetailSiswa.vue";
import DataAyah from "@/components/DataAyah.vue";
import DataIbu from "@/components/DataIbu.vue";
import DataWali from "@/components/DataWali.vue";
import SiswaView from "@/views/SiswaView.vue";
import UtamaView from "@/views/UtamaView.vue";
import PendukungView from "@/views/PendukungView.vue";
import BerkebutuhanKhusus from "@/components/BerkebutuhanKhusus.vue";
import CitaCita from "@/components/CitaCita.vue";
import DataHobi from "@/components/DataHobi.vue";
import ModaTransportasi from "@/components/ModaTransportasi.vue";
import DataPekerjaan from "@/components/DataPekerjaan.vue";
import DataPendidikan from "@/components/DataPendidikan.vue";
import PendidiknDasar from "@/components/PendidiknDasar.vue";
import DataPenghasilan from "@/components/DataPenghasilan.vue";
import StatusOrtu from "@/components/StatusOrtu.vue";
import TempatTinggal from "@/components/TempatTinggal.vue";
import ProgresSiswaView from "@/views/ProgresSiswaView.vue";

const appTitle = process.env.VUE_APP_TITLE;

const routes = [
	{
		path: "/",
		name: "home",
		alias: ["/home"],
		component: HomeView,
		meta: {
			type: "menu",
			icon: "bi bi-house-fill",
			menuTitle: "Beranda",
			page: {
				tab: appTitle,
				header: "Beranda",
				label: "Beranda",
			},
			allowedTypes: ["admin", "guru", "karyawan", "siswa"],
			allowedRoles: ["dev", "superadmin", "admin-kesiswaan", "admin-buku-induk", "pengelola", "staf", "wali-kelas", "guru-bk", "siswa"],
		},
		children: [
			{
				path: "detail",
				name: "detail",
				component: DetailSiswa,
				meta: {
					type: "page",
					page: {
						tab: `Detail Siswa · ${appTitle}`,
						header: "Detail Siswa",
						label: "Detail Siswa",
					},
					allowedTypes: ["siswa"],
				},
			},
			{
				path: "data-ayah",
				name: "data-ayah",
				component: DataAyah,
				meta: {
					type: "page",
					page: {
						tab: `Data Ayah · ${appTitle}`,
						header: "Data Ayah",
						label: "Data Ayah",
					},
					allowedTypes: ["siswa"],
				},
			},
			{
				path: "data-ibu",
				name: "data-ibu",
				component: DataIbu,
				meta: {
					type: "page",
					page: {
						tab: `Data Ibu · ${appTitle}`,
						header: "Data Ibu",
						label: "Data Ibu",
					},
					allowedTypes: ["siswa"],
				},
			},
			{
				path: "data-wali",
				name: "data-wali",
				component: DataWali,
				meta: {
					type: "page",
					page: {
						tab: `Data Wali · ${appTitle}`,
						header: "Data Wali",
						label: "Data Wali",
					},
					allowedTypes: ["siswa"],
				},
			},
		],
	},
	{
		path: "/rombel/:rombelId(\\d+)",
		name: "rombel",
		component: RombelView,
		meta: {
			type: "sub-menu",
			icon: "bi bi-layers-fill",
			menuTitle: "Rombongan Belajar",
			activeMenu: (route) => {
				return `/rombel/${route.params.rombelId}`;
			},
			page: (store, route) => {
				const rombelStatus = store.getters["rombel/getStatusById"](route.params.rombelId);
				const rombel = store.getters["rombel/getDataById"](route.params.rombelId);

				const result = {
					tab: "Rombongan Belajar",
					header: "Progres Data Siswa",
					label: "Rombongan Belajar",
				};
				switch (rombelStatus) {
					case "success":
						result.tab = rombel.nama;
						result.header += ` ${rombel.nama}`;
						result.label = rombel.nama;
						break;
					case "not_found":
						result.tab = "404 (Rombongan Belajar)";
						result.header = "Rombongan Belajar Tidak Ditemukan";
						result.label = "Rombongan Belajar Tidak Ditemukan";
						break;
					case "error":
						result.tab = "Terjadi Kesalahan";
						result.header = "Terjadi Kesalahan";
						result.label = "Terjadi Kesalahan";
						break;
					default:
						break;
				}

				result.tab += ` · ${appTitle}`;
				return result;
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "superadmin", "admin-kesiswaan", "admin-buku-induk", "pengelola", "staf", "wali-kelas", "guru-bk"],
		},
		children: [
			{
				path: "siswa/:siswaId(\\d+)",
				name: "rombel-siswa-progres",
				component: ProgresSiswaView,
				meta: {
					activeMenu: (route) => {
						return `/rombel/${route.params.rombelId}`;
					},
					page: (store, route) => {
						const rombelStatus = store.getters["rombel/getStatusById"](route.params.rombelId);
						const rombel = store.getters["rombel/getDataById"](route.params.rombelId);

						const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
						const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

						const result = {
							tab: "Rombongan Belajar · Siswa",
							header: "Progres Data Siswa",
							label: "Siswa",
						};
						switch (rombelStatus) {
							case "success":
								result.tab = rombel.nama;
								break;
							case "not_found":
								result.tab = "404 (Rombongan Belajar)";
								break;
							case "error":
								result.tab = "Terjadi Kesalahan";
								break;
							default:
								break;
						}

						switch (siswaStatus) {
							case "success":
								result.tab += ` · ${siswa.nama}`;
								result.label = siswa.nama;
								break;
							case "not_found":
								result.tab += " · 404 (Siswa)";
								result.header = "Siswa Tidak Ditemukan";
								result.label = "Siswa Tidak Ditemukan";
								break;
							case "error":
								result.tab += " · Terjadi Kesalahan";
								result.header = "Terjadi Kesalahan";
								result.label = "Terjadi Kesalahan";
								break;
							default:
								break;
						}

						result.tab += ` · ${appTitle}`;
						return result;
					},
				},
				children: [
					{
						path: "detail",
						name: "rombel-siswa-detail",
						component: DetailSiswa,
						meta: {
							type: "page",
							activeMenu: (route) => {
								return `/rombel/${route.params.rombelId}`;
							},
							page: (store, route) => {
								const rombelStatus = store.getters["rombel/getStatusById"](route.params.rombelId);
								const rombel = store.getters["rombel/getDataById"](route.params.rombelId);

								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Detail Siswa",
									header: "Detail Siswa",
									label: "Detail Siswa",
								};
								switch (rombelStatus) {
									case "success":
										result.tab += ` · ${rombel.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Rombongan Belajar)";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										break;
									default:
										break;
								}

								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header = "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
					{
						path: "data-ayah",
						name: "rombel-siswa-data-ayah",
						component: DataAyah,
						meta: {
							type: "page",
							activeMenu: (route) => {
								return `/rombel/${route.params.rombelId}`;
							},
							page: (store, route) => {
								const rombelStatus = store.getters["rombel/getStatusById"](route.params.rombelId);
								const rombel = store.getters["rombel/getDataById"](route.params.rombelId);

								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Data Ayah",
									header: "Data Ayah",
									label: "Data Ayah",
								};
								switch (rombelStatus) {
									case "success":
										result.tab += ` · ${rombel.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Rombongan Belajar)";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										break;
									default:
										break;
								}

								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header += "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
					{
						path: "data-ibu",
						name: "rombel-siswa-data-ibu",
						component: DataIbu,
						meta: {
							type: "page",
							activeMenu: (route) => {
								return `/rombel/${route.params.rombelId}`;
							},
							page: (store, route) => {
								const rombelStatus = store.getters["rombel/getStatusById"](route.params.rombelId);
								const rombel = store.getters["rombel/getDataById"](route.params.rombelId);

								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Data Ibu",
									header: "Data Ibu",
									label: "Data Ibu",
								};
								switch (rombelStatus) {
									case "success":
										result.tab += ` · ${rombel.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Rombongan Belajar)";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										break;
									default:
										break;
								}

								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header = "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
					{
						path: "data-wali",
						name: "rombel-siswa-data-wali",
						component: DataWali,
						meta: {
							type: "page",
							activeMenu: (route) => {
								return `/rombel/${route.params.rombelId}`;
							},
							page: (store, route) => {
								const rombelStatus = store.getters["rombel/getStatusById"](route.params.rombelId);
								const rombel = store.getters["rombel/getDataById"](route.params.rombelId);

								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Data Wali",
									header: "Data Wali",
									label: "Data Wali",
								};
								switch (rombelStatus) {
									case "success":
										result.tab += ` · ${rombel.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Rombongan Belajar)";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										break;
									default:
										break;
								}

								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header = "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
				],
			},
		],
	},
	{
		path: "/siswa",
		name: "siswa",
		component: SiswaView,
		meta: {
			type: "menu",
			icon: "bi bi-people-fill",
			menuTitle: "Siswa",
			page: {
				tab: `Data Siswa · ${appTitle}`,
				header: "Data Siswa",
				label: "Data Siswa",
			},
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "superadmin", "admin-kesiswaan", "admin-buku-induk", "pengelola", "staf"],
		},
		children: [
			{
				path: ":siswaId(\\d+)",
				name: "siswa-progres",
				component: ProgresSiswaView,
				meta: {
					type: "page",
					activeMenu: "/siswa",
					page: (store, route) => {
						const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
						const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

						const result = {
							tab: "Data Siswa",
							header: "Progres Data Siswa",
							label: "Siswa",
						};
						switch (siswaStatus) {
							case "success":
								result.tab = siswa.nama;
								result.label = siswa.nama;
								break;
							case "not_found":
								result.tab = "404 · Data Siswa";
								result.header = "Siswa Tidak Ditemukan";
								break;
							case "error":
								result.tab = "Terjadi Kesalahan";
								result.header = "Terjadi Kesalahan";
								break;
							default:
								break;
						}

						result.tab += ` · ${appTitle}`;
						return result;
					},
				},
				children: [
					{
						path: "detail",
						name: "siswa-detail",
						component: DetailSiswa,
						meta: {
							type: "page",
							activeMenu: "/siswa",
							page: (store, route) => {
								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Detail Siswa",
									header: "Detail Siswa",
									label: "Detail Siswa",
								};

								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header = "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
					{
						path: "data-ayah",
						name: "siswa-data-ayah",
						component: DataAyah,
						meta: {
							type: "page",
							activeMenu: "/siswa",
							page: (store, route) => {
								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Data Ayah",
									header: "Data Ayah",
									label: "Data Ayah",
								};

								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header = "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
					{
						path: "data-ibu",
						name: "siswa-data-ibu",
						component: DataIbu,
						meta: {
							type: "page",
							activeMenu: "/siswa",
							page: (store, route) => {
								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Data Ibu",
									header: "Data Ibu",
									label: "Data Ibu",
								};

								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header = "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
					{
						path: "data-wali",
						name: "siswa-data-wali",
						component: DataWali,
						meta: {
							type: "page",
							activeMenu: "/siswa",
							page: (store, route) => {
								const siswaStatus = store.getters["siswa/getStatusById"](route.params.siswaId);
								const siswa = store.getters["siswa/getDataById"](route.params.siswaId);

								const result = {
									tab: "Data Wali",
									header: "Data Wali",
									label: "Data Wali",
								};
								switch (siswaStatus) {
									case "success":
										result.tab += ` · ${siswa.nama}`;
										break;
									case "not_found":
										result.tab += " · 404 (Siswa)";
										result.header = "Siswa Tidak Ditemukan";
										break;
									case "error":
										result.tab += " · Terjadi Kesalahan";
										result.header = "Terjadi Kesalahan";
										break;
									default:
										break;
								}

								result.tab += ` · ${appTitle}`;
								return result;
							},
						},
					},
				],
			},
		],
	},
	{
		path: "/pengelolaan",
		name: "",
		meta: {
			type: "sub-menu",
			icon: "bi bi-sliders",
			menuTitle: "Pengelolaan",
			allowedTypes: ["admin", "guru", "karyawan"],
			allowedRoles: ["dev", "superadmin", "admin-kesiswaan", "pengelola"],
		},
		children: [
			{
				path: "data-utama",
				name: "data-utama",
				component: UtamaView,
				meta: {
					type: "page",
					menuTitle: "Data Utama",
					page: {
						tab: `Kelola Data Utama · ${appTitle}`,
						header: "Pengelolaan Data Utama",
						label: "Data Utama",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "superadmin", "admin-kesiswaan", "pengelola"],
				},
			},
			{
				path: "data-pendukung",
				name: "data-pendukung",
				component: PendukungView,
				meta: {
					type: "page",
					menuTitle: "Data Pendukung",
					page: {
						tab: `Kelola Data Pendukung · ${appTitle}`,
						header: "Pengelolaan Data Pendukung",
						label: "Data Pendukung",
					},
					allowedTypes: ["admin", "guru", "karyawan"],
					allowedRoles: ["dev", "superadmin", "admin-kesiswaan", "pengelola"],
				},
				children: [
					{
						path: "berkebutuhan-khusus",
						name: "berkebutuhan-khusus",
						component: BerkebutuhanKhusus,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Jenis Kebutuhan Khusus · ${appTitle}`,
								header: "Pengelolaan Data Jenis Kebutuhan Khusus ",
								label: "Kebutuhan Khusus",
							},
						},
					},
					{
						path: "cita-cita",
						name: "cita-cita",
						component: CitaCita,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Data Cita-cita · ${appTitle}`,
								header: "Pengelolaan Data Cita-cita ",
								label: "Cita-cita",
							},
						},
					},
					{
						path: "hobi",
						name: "hobi",
						component: DataHobi,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Data Hobi · ${appTitle}`,
								header: "Pengelolaan Data Hobi",
								label: "Hobi",
							},
						},
					},
					{
						path: "moda-transportasi",
						name: "moda-transportasi",
						component: ModaTransportasi,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Jenis Moda Transportasi· ${appTitle}`,
								header: "Pengelolaan Data Jenis Moda Transportasi",
								label: "Moda Transportasi",
							},
						},
					},
					{
						path: "pekerjaan",
						name: "pekerjaan",
						component: DataPekerjaan,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Jenis Pekerjaan · ${appTitle}`,
								header: "Pengelolaan Data Jenis Pekerjaan",
								label: "Jenis Pekerjaan",
							},
						},
					},
					{
						path: "pendidikan",
						name: "pendidikan",
						component: DataPendidikan,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Jenjang Pendidikan · ${appTitle}`,
								header: "Pengalolaan Data Jenjang Pendidikan",
								label: "Jenjang Pendidikan",
							},
						},
					},
					{
						path: "pendidikan-dasar",
						name: "pendidikan-dasar",
						component: PendidiknDasar,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Jenis Pendidikan Dasar · ${appTitle}`,
								header: "Pengelolaan Data Jenis Pendidikan Dasar",
								label: "Pendidikan Dasar",
							},
						},
					},
					{
						path: "penghasilan",
						name: "penghasilan",
						component: DataPenghasilan,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Rentang Penghasilan · ${appTitle}`,
								header: "Pengelolaan Data Rentang Penghasilan",
								label: "Rentang Penghasilan",
							},
						},
					},
					{
						path: "status-ortu",
						name: "status-ortu",
						component: StatusOrtu,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Status Orang Tua · ${appTitle}`,
								header: "Pengelolaan Data Jenis Status Orang Tua",
								label: "Status Orang Tua",
							},
						},
					},
					{
						path: "tempat-tinggal",
						name: "tempat-tinggal",
						component: TempatTinggal,
						meta: {
							type: "page",
							activeMenu: "/pengelolaan/data-pendukung",
							page: {
								tab: `Kelola Jenis Tempat Tinggal · ${appTitle}`,
								header: "Pengelolaan Data Jenis Tempat Tinggal",
								label: "Tempat Tinggal",
							},
						},
					},
				],
			},
		],
	},
	{
		path: "/profil",
		name: "profil",
		component: ProfileView,
		meta: {
			type: "page",
			page: {
				tab: `Pengaturan Pengguna · ${appTitle}`,
				header: "Pengaturan Pengguna",
				label: "Pengaturan Pengguna",
			},
			allowedTypes: ["admin", "guru", "karyawan", "siswa"],
		},
	},
	{
		path: "/forbidden/:halaman(.*)?",
		name: "forbidden",
		component: ForbiddenView,
		meta: {
			page: {
				tab: `Akses Tidak Diizinkan · ${appTitle}`,
			},
		},
	},
	{
		path: "/:catchAll(.*)",
		name: "not-found",
		component: NotFound,
		meta: {
			page: {
				tab: `Halaman Tidak Ditemukan · ${appTitle}`,
			},
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach((to, from, next) => {
	const user = store.getters.getUser;
	const roles = store.getters.getRoles;

	const { allowedTypes = [], allowedRoles = [] } = to.meta;

	const isAllowedType = !allowedTypes.length || allowedTypes.includes(user?.type);
	const isAllowedRole = !allowedRoles.length || roles?.some((r) => allowedRoles.includes(r.role)) || allowedRoles.includes(user?.type);

	if (!isAllowedType || !isAllowedRole) {
		return next("/forbidden/" + to.name);
	}

	next();
});

export default router;
